// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"33468":"1e68d1a1b3608738","62174":"575c338e65a140e3"}[chunkId] + ".css";
};